import Alpine from 'alpinejs';

Alpine.data('advocacy', (config = {}) => ({
    // State
    activeFilters: [],
    modalOpen: false,
    currentCampaign: null,
    currentStep: 1,
    selectedConstituency: '',
    letterText: '',
    letterTemplate: '',
    tds: [],
    loadingTds: false,
    tdError: null,
    selectedTd: null,
    showToast: false,
    toastMessage: '',

    // Config from PHP
    member: config.member || { name: '', company: '', email: '', address: '' },
    campaigns: config.campaigns || [],

    // Methods
    filterCampaigns(category) {
        if (category === 'all') {
            this.activeFilters = [];
            return;
        }
        const i = this.activeFilters.indexOf(category);
        if (i === -1) {
            this.activeFilters.push(category);
        } else {
            this.activeFilters.splice(i, 1);
        }
    },

    openModal(campaignId) {
        this.currentCampaign = this.campaigns.find(c => c.id === campaignId);
        if (!this.currentCampaign) return;

        this.letterTemplate = this.currentCampaign.letterTemplate;
        this.letterText = this.renderLetter('TD');
        this.currentStep = 1;
        this.selectedConstituency = '';
        this.tds = [];
        this.selectedTd = null;
        this.tdError = null;
        this.modalOpen = true;
        document.body.style.overflow = 'hidden';
    },

    closeModal() {
        this.modalOpen = false;
        document.body.style.overflow = '';
    },

    nextStep() {
        if (this.currentStep < 3) {
            if (this.currentStep === 1 && this.tds.length > 0) {
                this.letterText = this.renderLetter(this.selectedTd ? this.selectedTd.name : 'TD');
            }
            this.currentStep++;
        }
    },

    prevStep() {
        if (this.currentStep > 1) this.currentStep--;
    },

    async fetchTds(constituencySlug) {
        if (!constituencySlug) return;

        this.loadingTds = true;
        this.tdError = null;
        this.tds = [];

        try {
            const response = await fetch(`/td-data/${constituencySlug}`);
            if (!response.ok) throw new Error('Failed to load TD data');
            const data = await response.json();
            this.tds = data.tds || [];
            if (this.tds.length === 0) {
                this.tdError = 'No TD data found for this constituency. Please try again later.';
            }
        } catch (e) {
            this.tdError = 'Could not load TD data. You can still write your letter and find your TD at contactyourtd.ie';
            console.error('TD fetch error:', e);
        } finally {
            this.loadingTds = false;
        }
    },

    renderLetter(tdName) {
        if (!this.letterTemplate) return '';
        let letter = this.letterTemplate;
        letter = letter.replace(/\[TD Name\]/g, tdName || 'TD');
        letter = letter.replace(/\[Your name\]/g, this.member.name || '[Your name]');
        letter = letter.replace(/\[Your company\]/g, this.member.company || '[Your company]');
        letter = letter.replace(/\[Your address\]/g, this.member.address || '[Your address]');
        return letter;
    },

    getMailtoUrl(td) {
        const body = this.renderLetter(td.name);
        const subject = this.currentCampaign ? this.currentCampaign.emailSubject : '';
        const cc = this.currentCampaign && this.currentCampaign.ccEmail
            ? `cc=${encodeURIComponent(this.currentCampaign.ccEmail)}&`
            : '';
        return `mailto:${td.email}?${cc}subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    },

    getMailtoAllUrl() {
        const emails = this.tds.map(td => td.email).join(',');
        const body = this.renderLetter('TD');
        const subject = this.currentCampaign ? this.currentCampaign.emailSubject : '';
        const cc = this.currentCampaign && this.currentCampaign.ccEmail
            ? `cc=${encodeURIComponent(this.currentCampaign.ccEmail)}&`
            : '';
        return `mailto:${emails}?${cc}subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    },

    copyLetter() {
        navigator.clipboard.writeText(this.letterText).then(() => {
            this.toast('Letter copied to clipboard');
        }).catch(() => {
            // Fallback for older browsers
            const textarea = document.createElement('textarea');
            textarea.value = this.letterText;
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand('copy');
            document.body.removeChild(textarea);
            this.toast('Letter copied to clipboard');
        });
    },

    toast(message) {
        this.toastMessage = message;
        this.showToast = true;
        setTimeout(() => { this.showToast = false; }, 2800);
    },

    init() {
        // Alpine auto-initialises from x-data config
    }
}));

// Start Alpine
Alpine.start();
